import {styled, Box, Body1, DeleteOutlineIcon, CircularProgress, Alert, InfoIconMui} from '../../../ui-library';
import {BoxCustomImageProps, CustomImageProps} from '../Config/ImageUrl.types';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ImageContainer = styled(Box)<BoxCustomImageProps>(({ theme, overflow}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
    overflow: overflow,
    width: '100%',
    height: '100%',
    position: 'relative',
    aspectRatio: '1 / 1',
    userSelect: 'none'
}));


export const ResponsiveImg = styled('img')<CustomImageProps>(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ({ theme, isAspectRatio, isLoaded }) => ({
        width: isLoaded ? '100%' : '0px',
        ...(isAspectRatio ? {
            height: isLoaded ? '100%' : '0px',
            objectFit: 'contain',
        } : {
            objectFit: 'cover',
            maxHeight: '100%',
            aspectRatio: '1/1',
            borderRadius: '10px',
            display: `${isLoaded ? 'block' : 'none'}`})}));

export const DisableTitleRandom = styled(Body1)`
    color: #FFFFFF;
    font-size: 1vw;
    font-weight: 600;
`;
export const DisableTitleAutoClasses = styled(Body1)`
    color: #FFFFFF;
    font-size: 0.75rem;
    font-weight: 600;
    display: flex;
    position: absolute;
    bottom: 0;
    margin: 0px 6px 6px 6px;
    background: #00000080;
    border-radius: 7px;
    padding-left: 3px;
    padding-right: 3px;
`;

export const DeleteImage = styled(DeleteOutlineIcon)`
    color: #FFFFFF;
    cursor: pointer;
    z-index: var(--layer-1st);
`;

export const DisableContainerAutoClasses = styled(Box)`
    width: 100%;
    min-height: 100%;

`;

export const DisableContainerRandom = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    min-height: 100%;
`;

export const CircularProgressDisable = styled(CircularProgress)`
    color: #FFFFFF;
`;

export const CustomAlert = styled(Alert)`
    border: 1px solid #1E99FD;
    background: #F0F8FF;
`;

export const CustomInfoIcon = styled(InfoIconMui)`
color: #1E99FD
`;

